import Http from '@/api/http.js'

export default {

  index(filter) {
    // let search = ''
    // const {limit, page, level} = filter
    // search = `_page=${page}&_limit=${limit || 1000}&attributes.level=${level}`

    return Http.get(`/clients`, {params: {...filter}})
  },

  create(client){
    return Http.post(`/clients`, {client: {
      ...client,
      other_solution: 'retail',
      other_model: 'Modality',
      other_id: localStorage.getItem('modality_id'),
      document: client.document.replace(/[\W]/g, "")
    }})
  },

  update(client){
    return Http.put(`/clients/${client.id}`, {
      client: {
        ...client,
        corporate_name: client.name,
        document: client.document.replace(/[\W]/g, ""),
      },
    });
  },

  show(id) {
    return Http.get(`/clients/${id}`);
  },

  showClientLastOrder(filter = {}) {
    return Http.get(`/client_last_orders`, {params: {...filter}});
  },

  delete(){
    // return Http.delete(`/action_plans/${id}`)
  }

}
